module.exports = "<div class=\"row\" *ngIf=\"cart$ | async as cart\">\r\n    <div class=\"col-md-6\">\r\n        <shipping-form [cart]=\"cart\" ></shipping-form>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <shipping-order-summary [cart]=\"cart\"></shipping-order-summary>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/check-out/check-out.component.html
// module id = ../../../../../src/app/check-out/check-out.component.html
// module chunks = main